import {HttpEvent, HttpEventType, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {map} from 'rxjs/operators';

declare var moment: any;

@Injectable()
export class DateTypeInterceptor implements HttpInterceptor {
  private regexDateTime = /^\d{4}\-\d{2}\-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}.+$/;
  private regexDate = /^\d{4}\-\d{2}\-\d{2}$/;
  private regexTime = /^\d{2}:\d{2}:\d{2}\.\d{3}.+$/;
  private regexTimeNoTimeZone = /^\d{2}:\d{2}:\d{2}\.\d{3}$/;

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(this.parseRequest(req)).pipe(map(event => {
      if (event.type === HttpEventType.Response) {
        this.parseResponse(event as HttpResponse<any>);
      }

      return event;
    }));
  }

  private parseRequest(req: HttpRequest<any>) {
    if (req.headers.get('content-type') === 'application/json') {
      return req.clone({
        body: this.contertDateToString(req.body),
      });
    }

    return req;
  }

  parseResponse(response: HttpResponse<any>) {

    if (response.headers && response.headers.has('content-type') &&
      response.headers.get('content-type').indexOf('application/json') >= 0) {
      this.convertStringToDate(response.body);
    }
  }

  /**
   * Realiza a conversão de strings de datas em objetos Date javascript de acordo com o pattern definido pela API
   */
  public convertStringToDate(data: any) {
    let match;

    if (typeof data === 'string') {
      match = data.match(this.regexDateTime);
      if (match) {
        return moment(match[0]).toDate('YYYY-MM-DDTHH:mm:ss.SSSZZ');
      }

      match = data.match(this.regexDate);
      if (match) {
        return moment(match[0]).toDate('YYYY-MM-DD');
      }

      match = data.match(this.regexTime);
      if (match) {
        return moment(`1970-01-01T${match[0]}`).toDate('YYYY-MM-DDTHH:mm:ss.SSSZZ');
      }

      match = data.match(this.regexTimeNoTimeZone);
      if (match) {
        return moment(`1970-01-01T${match[0]}`).toDate('YYYY-MM-DDTHH:mm:ss.SSS');
      }
    } else if (Array.isArray(data)) {
      for (let i = 0; i < data.length; i++) {
        data[i] = this.convertStringToDate(data[i]);
      }
    } else if (typeof data === 'object' && !!data) {
      for (const key of Object.keys(data)) {
        data[key] = this.convertStringToDate(data[key]);
      }
    }

    return data;
  }

  private contertDateToString(data: any) {
    if (data === null || data === undefined) {
      return data;
    } else if (data instanceof Date) {
      return moment(data).format('YYYY-MM-DDTHH:mm:ss.SSSZZ');
    } else if (Array.isArray(data)) {
      const parsed = [];
      for (let i = 0; i < data.length; i++) {
        parsed[i] = this.contertDateToString(data[i]);
      }
      return parsed;
    } else if (typeof data === 'object' && !!data) {
      const parsed = {};
      for (const key of Object.keys(data)) {
        parsed[key] = this.contertDateToString(data[key]);
      }
      return parsed;
    }

    return data;
  }
}
